import { render, staticRenderFns } from "./RenameGroupModal.vue?vue&type=template&id=7994b56e"
import script from "./RenameGroupModal.vue?vue&type=script&lang=js"
export * from "./RenameGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports